import * as React from 'react';
import px from 'prop-types';
import { useCreditCard } from 'Common/hooks/payment';
import ExpDateForm from './ExpDateForm';

export default function IsoExpDateForm({ options, scope, usePlaceholders = false }) {
    const { labelProps } = useCreditCard({
        scope,
        options,
        usePlaceholders,
    });

    return (
        <ExpDateForm
            className={'col-8'}
            scope={scope}
            {...labelProps('Commerce.Order.Checkout.Payments.Card.Date.Label')}
            inputMode="numeric"
            maintainCursor
            hookAutofill
            trimOnInput
            required
        />
    );
}

IsoExpDateForm.propTypes = {
    options: px.shape({
        EnabledCardTypes: px.string,
        EnvKey: px.string,
        XiInterceptMerchantGuid: px.string,
        XiInterceptUrl: px.string,
        XiInterceptCallbackUrl: px.string,
    }),
    vertical: px.bool,
    scope: px.string,
    hideExtendedFields: px.bool,
    usePlaceholders: px.bool,
};
